<template>
  <div class="rt-card" :style="{ minWidth: width }">
    <header>
      <slot name="header"
        ><p class="rt-card-header">{{ title }}</p>
        </slot
      >
      <slot name='extra' />
    </header>
    <main class="rt-card-main" :style="{ height: height}">
      <slot> </slot>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    height: {
      type: [String, Number],
      default: "auto",
    },
    width: {
      type: [String, Number],
      default: "auto",
    }
  },
  computed: {
    mainHeight: function () {
      return typeof this.height === "number" ? this.height + "px" : this.height;
    },
  },
};
</script>

<style lang="scss" scoped>
.rt-card {
  background: #fff;
  .rt-card-header {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    opacity: 1;
    text-align: left;
    padding: 15px 30px;
  }
  /*& .rt-card-main {*/
  /*  overflow: auto;*/
  /*}*/
}
</style>
